import { render, staticRenderFns } from "./TableNoResultFound.vue?vue&type=template&id=456c4b7c"
import script from "./TableNoResultFound.vue?vue&type=script&lang=js"
export * from "./TableNoResultFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports